import { memo } from 'react';
import { useMediaQuery } from '@mui/material';

import { RoomFooterWeb } from './screen';
import { RoomFooterMobile } from './mobile';

const RoomFooter = () => {
  const isMobile = useMediaQuery('(max-width:768px)');

  return <>{isMobile ? <RoomFooterMobile /> : <RoomFooterWeb />}</>;
};

export default memo(RoomFooter);
